export default __webpack_public_path__ + "static/media/photo--sm--96.d2680443.jpg";